/**
 * 该主题仅用于大屏
 * */ 
import store from '@/store';
import { themeColor, ThemeType } from '@/assets/data/theme';
import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import { toggleTheme } from '@/utils/dom.util';

interface ThemeState {
  themeType: ThemeType
}

@Module({ name: 'theme', dynamic: true, namespaced: true, store })
class Theme extends VuexModule implements ThemeState {
  themeType: ThemeType = <ThemeType>localStorage.getItem('LOCAL_THEME_TYPE') || ThemeType.THEME_DARK;

  get themeColors () {
    if (!this.themeType) return {}
    return themeColor[this.themeType]
  }

  @Mutation
  private SET_THEME_TYPE (type: ThemeType) {
    this.themeType = type;
    localStorage.setItem('LOCAL_THEME_TYPE', type) 
  }

  @Action
  public setThemeType (type: ThemeType) {
    if (this.themeType === type) return
    this.SET_THEME_TYPE(type)
    toggleTheme(type)
  }
}

export const ThemeModule = getModule(Theme)
